export enum Icons {
  BOOK = "/icons/book.svg",
  DOCUMENT = "/icons/document.svg",
  INTERNET = "/icons/internet.svg",
}
